import { render, staticRenderFns } from "./OneAccountDropdownComponent.vue?vue&type=template&id=285924a5&scoped=true&"
import script from "./OneAccountDropdownComponent.vue?vue&type=script&lang=ts&"
export * from "./OneAccountDropdownComponent.vue?vue&type=script&lang=ts&"
import style0 from "./OneAccountDropdownComponent.vue?vue&type=style&index=0&id=285924a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285924a5",
  null
  
)

export default component.exports